module.exports = __webpack_public_path__ + "static/media/20210212_211014_878_IMG_2134.911068f0.jpg";